var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('documents-filter-component',{attrs:{"ui":_vm.ui,"routeDetails":_vm.routeDetails,"routeDocuments":_vm.routeDocuments}})}
var staticRenderFns = []

export { render, staticRenderFns }